import { createFreezeOffUpdate, createFreezeOnUpdate } from '@module/helpers/centrifuge/messageUpdates';
import constructFreezeOnPayload from '@module/helpers/chat/constructFreezeOnPayload';
import type { ParsedCentrifugeMessage } from '@module/types/centrifuge/messageTypes';
import {
  type FreezeOffMessage,
  type FreezeOnMessage,
  isFreezeOffMessage,
  isFreezeOnMessage,
} from '@module/types/centrifuge/public-message/freezeMessageTypes';
import type { MessageHandler, MessageHandlerAction, MessageHandlerContext } from '../types';

export class FreezeOnHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<FreezeOnMessage>) {}

  canHandle(payload: ParsedCentrifugeMessage): boolean {
    return isFreezeOnMessage(payload);
  }

  handle(payload: FreezeOnMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;
    if (!context.playInfo) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작
    context.setPlayInfo(createFreezeOnUpdate(payload, context.playInfo));
    context.setChatMessages((prev) => [
      ...prev,
      constructFreezeOnPayload({ name: payload.data.message.name, messageType: 'past' }),
    ]);
  }
}

export class FreezeOffHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<FreezeOffMessage>) {}

  canHandle(payload: ParsedCentrifugeMessage): boolean {
    return isFreezeOffMessage(payload);
  }

  handle(payload: FreezeOffMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;
    if (!context.playInfo) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작
    context.setPlayInfo(createFreezeOffUpdate(context.playInfo));
  }
}
